import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EnvironmentService } from '@services/environment.service';
import { NotificationsService } from '@services/notifications.service';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { HttpUtilService } from '@services/http-util.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-tableau',
    templateUrl: './tableau.component.html',
    styleUrls: ['./tableau.component.scss'],
    standalone: false
})
export class TableauComponent extends BaseScaffoldComponent implements OnInit {
  public showTableau: boolean = false;
  public error: boolean = false;
  public thirdPartyEnabled: boolean = true;
  public tableauViz: any;
  public token: '';
  public url = '';
  public width: '100%';
  public height: '500px';
  public initialRetry: boolean = true;

  constructor(
    public http: HttpUtilService,
    private translationService: TranslationService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    public environmentService: EnvironmentService,
    public notifications: NotificationsService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    // this.checkForThirdPartyCookie()
    //   .then((isEnabled) => {
    //     this.thirdPartyEnabled = isEnabled;
    //     if (!this.thirdPartyEnabled) {

    //       const text = this.translationService.getTranslatedContent('please_enable_cross_site_or_third_party_cookies_lingo','Please enable Cross Site or Third Party Cookies in order to View Tableau Dashboard.')
    //       this.notifications.popNotification(
    //         "",
    //         text
    //       );
    //     }

    if (this.item?.allow_style) this.setStyle();
    this.loadAuth();
    // })
    // .catch((error) => {
    //   console.log("error", error);
    //   this.error = true;
    //   const text = this.translationService.getTranslatedContent('unknown_error._unable_to_view_tableau_dashboard.',"Unknown error. Unable to View Tableau Dashboard.")

    //   this.notifications.popNotification(
    //     "",
    //     text
    //   );
    //   return;
    // });
  }

  // checkForThirdPartyCookie(): Promise<any> {
  //   return new Promise((res) => {
  //     try {
  //       cookieCheck({}).then(function (result) {
  //         res(result.supported);
  //       });
  //     } catch (err) {
  //       res(false);
  //     }
  //   });
  // }

  get containerStyles() {
    {
      return `height:${this.height};width:${this.width}`;
    }
  }

  setStyle() {
    const measurement = this.item.measure_of || 'px';
    const height = this.item.height || 400;
    const width = this.item.width || 400;

    this.height =
      measurement === 'vp'
        ? (`${height}vh` as any)
        : (`${height}${measurement}` as any);
    this.width =
      measurement === 'vp'
        ? (`${width}vw` as any)
        : (`${width}${measurement}` as any);
  }

  loadAuth() {
    this.http
      .request(
        'get',
        `${this.environmentService.environment.apiRoot}/tableau`,
        {},
        null,
        true
      )
      .subscribe((res: any) => {
        if (!res.body) {
          if (this.initialRetry) {
            this.initialRetry = false;
            return this.loadAuth();
          }
          this.error = true;
          this.cdr.detectChanges();

          const text = this.translationService.getTranslatedContent(
            'error_with_opening_tableau_dashboard_at_this_time',
            'Error with opening Tableau Dashboard at this time.'
          );
          return this.notifications.popNotification('', text);
        }
        const body = JSON.parse(res.body);

        if (!body?.token) {
          this.error = true;
          this.cdr.detectChanges();
          const text = this.translationService.getTranslatedContent(
            'error_with_opening_tableau_dashboard_at_this_time',
            'Error with opening Tableau Dashboard at this time.'
          );

          return this.notifications.popNotification('', text);
        }
        this.token = body.token;
        this.url = body.url || this.item.url;
        if (!this.url || !this.token) {
          this.error = true;
          this.cdr.detectChanges();
        }
        this.showTableau = true;
        this.cdr.detectChanges();
      });
  }
}
